<template>
  <a-row :gutter="24" :visible="visible" >
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <div>
                <span class="basicTitle">基本信息</span>
                <a-row>
                    <a-col :span="12/1">
                        <p>产品名称: </p>
                        <span>{{ material.materialName }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>编码：</p>
                        <span>{{ material.code }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>规格/型号:</p>
                        <span>{{ material.model }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>单位:</p>
                        <span>{{ material.unit }}</span>
                    </a-col>
                </a-row>
            </div>
            <div>
                <span class="lisenceTitle" >生产企业信息</span>
                <a-row>
                    <a-col :span="12/1">
                        <p>生产企业：</p>
                        <span>{{ supper.supplierName }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>编码：</p>
                        <span>{{ supper.supplierCode }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>营业执照号：</p>
                        <span>{{ supper.credit }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>附件:</p>
                        <span>{{ supper.attachment }}</span>
                    </a-col>
                </a-row>
            </div>

      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
//productLisenceDetail
import { campListMixins } from '../mixins/campListMixins'
import { ledgerDelete,ledgerEdit } from '@/api/api'
import JDate from '@/components/jeecg/JDate'


export default {
  name: 'RetailOutList',
  mixins: [campListMixins],
  components: {
    JDate,
  },
  props:{
    productInfo: {
      type: Object,
      default: {}
    }},
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      productId: '2',
      visible: false,
      material: {
        productName: '',
        code: '',
        model: '',
        unit: '',
      },
      supper: {
        supplierName: '',
        supplierCode: '',
        credit: '',
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // url: {
      //   list: '/sy/material/materialLicence/list',

      // },
    }
  },
  computed: {},
  created() {
    console.log(this.productInfo,'=======================55555555555555================')
    this.material = this.productInfo.material
    this.supper = this.productInfo.supper
  },
  methods: {
    initShow(e){
      this.material = e.material
      this.supper = e.supper

    },
    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    async handleAudit(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },
    //handleAuditCancel
    async handleAuditCancel(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },
    //查看证照详情
    getProductLisence(record){
      console.log(record)
      this.$refs.productLisenceModal.initShow(record)
    },
    //删除handleDelete
    async handleDelete(record) {
      let params = {
        id : record.uuid
      }
      const res = await ledgerDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.loadData()
      } else {
        this.$message.error(res.message)
      }

    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
    /deep/.ant-col {
        display: flex;
    }
    .basicTitle {
        display: block;
        font-size: 16x;
        margin: 0 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
    .lisenceTitle {
        display: block;
        font-size: 16x;
        margin: 30px 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }

</style>